export const doorlocHeaderFields = [
  { name: "Warehouse", label: "Warehouse" },
  { name: "Loc", label: "Location" },
  { name: "LocationType", label: "Location Type" },
  { name: "LocationCategory", label: "Location Category" },
  { name: "LocationHandling", label: "Location Handling" },
  { name: "ABC", label: "ABC Class" },
  { name: "Section", label: "Section" },
  { name: "LocationFlag", label: "Location Flag" },
  { name: "Status", label: "Status" },
  { name: "PickZone", label: "Pick Zone" },
  { name: "Height", label: "Height" },
  { name: "Length", label: "Length" },
  { name: "Width", label: "Width" },
  { name: "Cube", label: "Cube" },
  { name: "WeightCapacity", label: "Weight Capacity" },
  { name: "CubicCapacity", label: "Cubic Capacity" },
  { name: "PutawayZone", label: "Putaway Zone" },
  { name: "PickMethod", label: "Pick Method" },
  { name: "SectionKey", label: "Section Key" },
  { name: "XCoord", label: "X Coordinate" },
  { name: "YCoord", label: "Y Coordinate" },
  { name: "ZCoord", label: "Z Coordinate" },
  { name: "LocLevel", label: "Location Level" },
  { name: "CommingleSku", label: "Commingle SKU" },
  { name: "CommingleLot", label: "Commingle Lot" },
  { name: "StackLimit", label: "Stack Limit" },
  { name: "FootPrint", label: "Foot Print" },
  { name: "BackflushIndicator", label: "Backflush Indicator" },
  { name: "Facility", label: "Facility" },
  { name: "AddDate", label: "Add Date" },
  { name: "addwho", label: "Added By" },
  { name: "editwho", label: "Edited By" },
  { name: "editdate", label: "Edit Date", type: "text", readOnly: true },
];